import { HeroStatisticsProps } from '@ahc-digital/component-library';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { HERO_STATISTICS_CONTAINER } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C52HeroStatisticsProps } from './C52HeroStatistics.types';

export function GetHeroStatisticsModel(props?: C52HeroStatisticsProps): HeroStatisticsProps {
  type t = HeroStatisticsProps;

  const { fields, params, rendering } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    contentAlignments: getDroplink<t['contentAlignments']>(params?.ContentAlignments, 'center'),
    ctaAlignment: getDroplink<t['ctaAlignment']>(params?.CtaAlignment, 'center'),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    numberOfColumnsMobile: getDroplink<t['numberOfColumnsMobile']>(
      params?.NumberOfColumnsMobile,
      '1'
    ),
    numberOfColumns: getDroplink<t['numberOfColumns']>(params?.NumberOfColumns, '4'),
    shouldShowColumnDividers: getCheckbox(params?.ShowColumnDividers),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    cta: renderLink(fields?.Cta),
    children: rendering && (
      <Placeholder
        name={`${HERO_STATISTICS_CONTAINER}-${params?.DynamicPlaceholderId}`}
        rendering={rendering}
      />
    ),
  };
}
